module.exports = __webpack_public_path__ + "../resources/img/storebadge_en.e6d552c5.png";